import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import Cookies from 'js-cookie';
import CreatProfileRoutes from './CreatProfileRoutes';
import AdminRoutes from './AdminRoutes';
import { checkForAuthorization } from 'utils/index';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    var routes = (checkForAuthorization() !== "" && checkForAuthorization() !== undefined) ? ((Cookies.get("is_profile_complete") != "" && Cookies.get("is_profile_complete") !== undefined) && Cookies.get("is_profile_complete") != "false" ? (Cookies.get("permissions") ? AdminRoutes : AdminRoutes) : AdminRoutes) : AuthenticationRoutes;
    return useRoutes([routes])
}
